/*
<div>
                <el-divider content-position="left">只能输入正负数，包括小数点</el-divider>
                <el-input v-model="form.number" oninput="value = value.replace(/[^\d\.-]/g, '')" />
                <el-divider content-position="left">只能输入正数，不包括小数点</el-divider>
                <el-input v-model="form.number" oninput="value = value.replace(/[^\d]/g, '')" />
                <el-divider content-position="left">只能输入字母或数字</el-divider>
                <el-input v-model="form.number" oninput="value = valvalue = value.replace(/[\W]/g, '')" />

                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="300px">
                    <el-form-item label="身份证号" prop="idCard"><el-input v-model="form.idCard" /></el-form-item>
                    <el-form-item label="手机号" prop="phone"><el-input v-model="form.phone" /></el-form-item>
                    <el-form-item label="联系方式（座机/移动电话/手机号）" prop="tel"><el-input v-model="form.tel" /></el-form-item>
                    <el-form-item label="年龄" prop="age"><el-input v-model.number="form.age" oninput="value = value.replace(/[^\d]/g, '')" /></el-form-item>
                    <el-form-item label="电子邮件" prop="email"><el-input v-model="form.email" /></el-form-item>
                    <el-form-item label="密码" prop="pwd"><el-input v-model="form.pwd" /></el-form-item>
                    <el-form-item label="重复密码" prop="rePwd"><el-input v-model="form.rePwd" /></el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    </el-form-item>
                </el-form>
        </div>
 */


export default {
    data () {
        return {
            ValidatorForm: {
                number: '',
                idCard: '',
                phone: '',
                email: '',
                tel: '',
                age: '',
                pwd: '',
                rePwd: ''
            },
            ValidatorRules: {
                idCard: { required: true, validator: this.idCardValidator, trigger: ['blur', 'change'] },
                phone: { required: true, validator: this.phoneValidator, trigger: ['blur', 'change'] },
                email: { required: true, validator: this.emailValidator, trigger: ['blur', 'change'] },
                tel: { required: true, validator: this.telValidator, trigger: ['blur', 'change'] },
                pwd: { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
                rePwd: { required: true, validator: this.passValidator, trigger: ['blur', 'change'] },
                age: { required: true, validator: this.ageValidator, trigger: ['blur', 'change'] }
            }
        }
    },
    methods: {
        idCardValidator (rule, value, callback) {
            if (!value && rule.required) {
                return callback(new Error('请输入身份证号'))
            }
            if (value && !this.$jtool.validate.checkIdCard(value)) {
                return callback(new Error('请输入有效的身份证号'))
            }
            callback()
        },
        phoneValidator (rule, value, callback) {
            if (!value && rule.required) {
                return callback(new Error('请输入手机号'))
            }
            if (value && !this.$jtool.validate.checkPhone(value)) {
                return callback(new Error('请输入正确的手机号'))
            }
            callback()
        },
        telValidator (rule, value, callback) {
            if (!value && rule.required) {
                return callback(new Error('请输入联系方式'))
            }
            if (value && !this.$jtool.validate.checkTel(value)) {
                return callback(new Error('请输入有效的联系方式'))
            }
            callback()
        },
        emailValidator (rule, value, callback) {
            if (!value && rule.required) {
                return callback(new Error('请输入邮箱地址'))
            }
            if (value && !this.$jtool.validate.checkEmail(value)) {
                return callback(new Error('请输入有效的邮箱地址'))
            }
            callback()
        },
        ageValidator (rule, value, callback) {
            if (!value && rule.required) {
                return callback(new Error('请输入年龄'));
            }
            if (!Number.isInteger(value)) {
                callback(new Error('请输入数字值'));
            } else {
                if (value < 18) {
                    callback(new Error('必须年满18岁'));
                } else {
                    callback();
                }
            }
        },
        passValidator (rule, value, callback) {
            if (!value && rule.required) {
                callback(new Error('请确认密码'));
            } else if (value != this.form.pwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        }
    }
}
